export default __webpack_public_path__ + "static/media/myWorkNest_Purple_Positive_RGB.5ee4a14a.svg";